export default __webpack_public_path__ + "static/real-survey-b48851c26cfaf6de100c6f9d6fa0321b.gif";